import React, { useState, useEffect, useRef } from 'react'
import * as Survey from "survey-react";
import AttestationStatusComp from "./AttestationStatusComp";
import CommentComp from "../common/CommentComp";
import SurveyJsComp from "../common/SurveyJsComp";
import AttestationStatus, { ReviewingStatus, ReviewingStatusLabel, CompletedStatus, CompletedStatusLabel } from "../../common/attestationStatus";

const AttestationForm = (props)=> {
    console.log(props.editorItem.exportFormat);
    const [canBeReopened, setCanBeReopened] = useState(false);
    const onSubmit = useRef(null);
    const isReadOnly = AttestationStatus.isReadOnly(props.editorItem.status);
    const survey = new Survey.Model(props.editorItem.template);

    useEffect(() => {
        setCanBeReopened(AttestationStatus.canBeReopened(props.editorItem.status));
    })

    const onComplete = (result, options) =>{
        props.editorItem.status = CompletedStatus;
        props.editorItem.statusLabel = CompletedStatusLabel;
        props.handleSubmitClick({...props.editorItem,formData:result.data});
    }

    const onReopen = () => {
        props.handleReopen(props.editorItem);
        props.editorItem.statusLabel = ReviewingStatusLabel;
        props.editorItem.status = ReviewingStatus;
        setCanBeReopened(false);
    }
    const onExport = ()=>{
        props.handleExport(props.editorItem.id,'PersonalTransactionReport.xlsx');
    }

    return (
        <div className="panel">
            <div className="panel-header no-print">
                <div className="push-left flex">
                    <div className="ml-4 mr-4">Attestation Status : <AttestationStatusComp status={props.editorItem.status}>{props.editorItem.statusLabel}</AttestationStatusComp></div>
                    <div className="ml-4 flex">
                        {props.editorItem.sentTimestamp && <div>Sent : {props.editorItem.sentTimestamp}</div>}
                        {props.editorItem.status === CompletedStatus && <div className="ml-4">{props.editorItem.statusLabel} : {props.editorItem.updatedTimestamp}</div>}
                    </div>
                </div>
                <div className="push-right">
                    <div className="btn-group">
                        { !isReadOnly &&
                            <button type="button" className="btn btn-primary" onClick={c => onSubmit.current()}>
                                Submit
                            </button> 
                        }
                        { canBeReopened &&
                            <button type="button" className="btn btn-primary" onClick={onReopen}>
                                Reopen
                            </button> 
                        }
                        <button type="button" className="btn btn-primary" onClick={c => props.handleClose(props.editorItem)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
            <div className="panel-body">
                <SurveyJsComp
                    isReadOnly={isReadOnly}
                    showNavButtons={false}
                    survey={survey}
                    formData={props.editorItem.formData}
                    handleSaveClick={data => props.handleSaveClick({...props.editorItem, formData: data})} 
                    onSubmit={onSubmit}
                    onComplete={onComplete} />
                <CommentComp data = {props.editorItem.comments}/>
            </div>
            <div className="panel-footer no-print">
                <div className="btn-group">

                    {props.editorItem.exportFormat && 
                        <button type="button" className="btn btn-primary" onClick={onExport}>
                            Export to excel
                        </button>
                    }
                    { !isReadOnly && 
                        <button type="button" className="btn btn-primary" onClick={c => onSubmit.current()}>
                            Submit
                        </button>
                    }
                    { canBeReopened &&
                        <button type="button" className="btn btn-primary" onClick={onReopen}>
                            Reopen
                        </button> 
                    }
                    <button type="button" className="btn btn-primary" onClick={c => props.handleClose(props.editorItem)}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AttestationForm
